import { useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { sendPageView } from "../helpers/ga";

// One GA page view per route the actor sees, the address cleaned of session keys (helpers/ga.ts).
// Inside the router, so every page of the app, the classic signup's included, gets the same.
const GaPageViews: React.FC<RouteComponentProps> = ({ location }) => {
  useEffect(() => {
    sendPageView();
  }, [location.pathname, location.search]);
  return null;
};

export default withRouter(GaPageViews);
